export default __webpack_public_path__ + "static/media/shop-categories-img06.ae5e5883.jpg";